import React from "react";

type IProps = [NodeJS.Timeout | undefined, () => void];

export const useInterval = (callback: () => void, delay: number, skip = false): IProps => {
	const savedCallback = React.useRef<() => void>();
	const [intervalId, setIntervalId] = React.useState<NodeJS.Timeout>();

	React.useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	React.useEffect(() => {
		const tick = () => {
			savedCallback?.current?.();
		};

		if (!skip && delay !== null) {
			const id = setInterval(tick, delay);
			setIntervalId(id);
			return () => clearInterval(intervalId);
		}
	}, [delay, skip]);

	return [intervalId, () => clearInterval(intervalId)];
};
